import { useSearchParams, Link } from "react-router-dom";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  return (
    <div className="max-w-md mx-auto px-5 py-20 text-center" data-testid="payment-cancel">
      <h1 className="font-display text-3xl font-semibold text-[var(--fpn-navy)]">Payment cancelled</h1>
      <p className="text-sm text-slate-500 mt-2">Your booking {ref ? <span className="font-mono">{ref}</span> : ""} has not been paid. It will expire shortly.</p>
      <Link to="/" className="btn-navy inline-block rounded-full px-6 py-3 text-sm mt-8">Back to search</Link>
    </div>
  );
}
